import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ReactNestable from 'react-nestable';
import {nodeFinder} from './helper-functions';

import * as Api from 'api';
import * as Actions from 'actions';

import {
  EditPermissionModal,
  AddPermissionModal,
  ConfirmationPrompt
} from '../';

class Nestable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      list : [],
      hovered_item : '',
      show_edit_modal : false,
      show_add_modal : false,
      show_delete_modal : false,
      show_force_delete_modal : false,
      force_delete_message : '',
      current_permission : null
    }

    this.styles = {
      position:   'relative',
      padding:    '10px 15px',
      fontSize:   '20px',
      border:     '1px solid #f9fafa',
      background: '#f9fafa',
    };

    this.renderItem = this.renderItem.bind(this)
    this.handler = this.handler.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.handleClickDelete = this.handleClickDelete.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleForceDelete = this.handleForceDelete.bind(this)
    this.handleClickAdd = this.handleClickAdd.bind(this)
    this.handleAddPermission = this.handleAddPermission.bind(this)
  }

  renderItem(options) {
    const {item, collapseIcon, handler} = options;
    return (
      <div
        style={this.styles}
        onMouseEnter={() => {setTimeout(this.setState({hovered_item : item.id}), 10)}}
        onMouseLeave={() => {this.setState({hovered_item : ''})}}
        >
        {this.state.hovered_item == item.id ? handler : <span />}
        {collapseIcon}
        {item.text}
      </div>
    )
  }

  handler() {
    return (
      <span>
        <div className='pull-right'>
          <i
            className='fa fa-trash animated fadeIn permissions-edit-button'
            onClick={this.handleClickDelete}
          />
        </div>
        <div className='pull-right mr-md'>
          <i
            className='fa fa-pencil animated fadeIn permissions-edit-button'
            onClick={this.handleClickEdit}
          />
        </div>
        <div className='pull-right mr-md'>
          <i
            className='fa fa-plus animated fadeIn permissions-add-button'
            onClick={this.handleClickAdd}
          />
        </div>
      </span>
    )
  }

  handleClickEdit() {
    let current_permission = nodeFinder(this.state.hovered_item, this.state.list)
    this.setState({show_edit_modal : true, current_permission})
  }

  handleEdit(new_name, new_description) {
    let updated_permission = {_id : this.state.current_permission.id, new_name, new_description}
    delete updated_permission.text;

    Api.updatePermission(updated_permission)
    .then(updated_permissions_list => {
      this.setState({current_permission : null, list : updated_permissions_list})
    })
    .catch(e => {
      this.setState({current_permission : null})
      this.props.notify({message : e.message | e})
    })
  }

  handleClickDelete() {
    this.setState({show_delete_modal : true, current_permission : {id : this.state.hovered_item}})
  }

  handleDelete() {
    Api.deletePermission(this.state.current_permission.id)
    .then(result => {
      if(result.prompt_force_delete) {
        this.setState({
          show_delete_modal : false,
          show_force_delete_modal : true,
          force_delete_message : result.message,
        })
      }
      else {
        this.setState({
          list : result,
          current_permission : null,
          show_delete_modal : false
        })
      }
    })
    .catch(e => {
      this.props.notify({message : e.message || e})
      this.setState({show_delete_modal : false})
    })
  }

  handleForceDelete() {
    Api.forceDeletePermission(this.state.current_permission.id)
    .then(updated_permissions_list => {
      this.setState({
        show_force_delete_modal : false,
        list : updated_permissions_list,
        current_permission : null
      })
    })
    .catch(e => {
      this.props.notify({message : e.message || e})
      this.setState({
        show_force_delete_modal : false,
        current_permission : null
      })
    })
  }

  handleClickAdd() {
    let current_permission = nodeFinder(this.state.hovered_item, this.state.list)
    this.setState({show_add_modal : true, current_permission})
  }

  handleAddPermission({name, description}) {
    const {current_permission} = this.state;
    const new_permission = {
      name, description,
      parent_id : current_permission ? this.state.current_permission.id : null
    }

    Api.addPermission(new_permission)
    .then(updated_permissions_list => {
      this.setState({
        current_permission : null,
        list : updated_permissions_list,
        show_add_modal : false
      })
    })
    .catch(e => {
      this.setState({
        current_permission : null,
        show_add_modal : false
      })
      this.props.notify({message : e.message | e})
    })
  }

  componentWillMount() {
    Api.getPermissions()
    .then(list => {this.setState({list})})
  }

  render() {
    return (
      <div className='permissions-nestable-container'>
        <EditPermissionModal
          show={this.state.show_edit_modal}
          onHide={() => {this.setState({show_edit_modal : false})}}
          current_name={this.state.current_permission ? this.state.current_permission.text : ''}
          current_description={this.state.current_permission ? this.state.current_permission.description : ''}
          handleSubmit={(name, description) => {this.handleEdit(name, description)}}
        />
        <AddPermissionModal
          show={this.state.show_add_modal}
          onHide={() => {this.setState({show_add_modal : false})}}
          handleSubmit={(new_permission) => {this.handleAddPermission(new_permission)}}
        />
        <ConfirmationPrompt
          show_condition={this.state.show_delete_modal}
          handleCancelPrompt={() => {this.setState({show_delete_modal : false})}}
          handleConfirmPrompt={this.handleDelete}
          type='danger'
          title='Delete Permission?'
          body={`Are you sure you want to delete this permission? This action will also
            delete any "child" permission. If you're not sure of this action, please
            contact a superior.`
          }
          confirm_button_text='Delete'
          cancel_button_text='Cancel'
        />
        <ConfirmationPrompt
          show_condition={this.state.show_force_delete_modal}
          handleCancelPrompt={() => {this.setState({show_force_delete_modal : false})}}
          handleConfirmPrompt={this.handleForceDelete}
          type='danger'
          title='Force Delete?'
          body={this.state.force_delete_message}
          confirm_button_text='Force Delete'
          cancel_button_text='Cancel'
        />
        <ReactNestable
          collapsed={true}
          group='1'
          items={this.state.list}
          renderItem={this.renderItem}
          handler={this.handler()}
        />
        <div className='btn btn-primary btn-block mt-md' onClick={this.handleClickAdd}>
          <i className='fa fa-plus' />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({users}) => ({users})

export default connect(mapStateToProps, Actions)(Nestable)



// WEBPACK FOOTER //
// ./src/browser/components/permissions/nestable.js